<mat-progress-bar
  [value]="uploadProgress"
  *ngIf="fileUploading"
  class="upload-progress"
></mat-progress-bar>

<div class="close-btn-container">
  <button (click)="close()" class="close-btn" mat-button type="button">
    <jam-icon name="close"></jam-icon>
  </button>
</div>

<!-- <div class="header"> -->
  <h3 mat-dialog-title class="header">آپلود فایل</h3>
<!-- </div> -->

<div fxLayout="column" fxLayoutAlign="space-between center" class="wrapper">
  <div
    class="drag-drop"
    fxFlex="100"
    fileDragDrop
    (fileUploadedEvent)="fileSelectionAdapter($event)"
  >
      <span class="disabled"
      >فرمت<span *ngIf="acceptableFormats.length > 1">‌های</span> قابل قبول: {{ acceptableFormats.join("، ") }}</span
    >
    <h3 class="title my-5">فایل‌های خود را درون این قسمت بکشید</h3>
    <h1 class="or">یا</h1>
    <button mat-raised-button color="primary" class="file-select-btn" [disabled]="fileUploading" cdkFocusInitial (click)="uploadInput.click()">
      <span *ngIf="!fileUploading">یک فایل انتخاب کنید</span>
      <span *ngIf="fileUploading">در حال آپلود...</span>
    </button>

    <form class="file-select-form" class="d-none">
      <input type="file" [accept]="generateAcceptForInput()" (change)="getAndUploadFromEvent($event)" #uploadInput />
    </form>

  </div>
</div>
